export default "__VITE_ASSET__5671a974__"